import { useRouter } from "next/router";
import usePermission from "hooks/use-permission";
import useUser from "hooks/use-user";
import { isSelectUser as isSelectUserFn } from "utils/access-group";

interface ContactInfoBtnProps {
  contact: string;
}

const ContactInfoBtn = ({ contact }: ContactInfoBtnProps) => {
  const router = useRouter();

  const hasCompanyContactViewPermission = usePermission("companyContactView");

  const user = useUser();
  const isFreeUser = user?.access?.group === "free";
  const isPublicUser = !user?.isLoggedIn || false;
  const isSelectUser = isSelectUserFn(user?.access?.group);
  const isCorporateUser = user?.access?.group === "corporate";

  function viewContactHandler() {
    if (!hasCompanyContactViewPermission && (isFreeUser || isPublicUser)) {
      const fullPath = `/account`;
      router.push({
        pathname: fullPath,
      });
    } else if (
      !hasCompanyContactViewPermission &&
      (isSelectUser || isCorporateUser)
    ) {
      const fullPath = "https://www.privco.com/contact";
      router.push({
        pathname: fullPath,
      });
    } else {
      const fullPath = `/company-contact/${
        window.location.pathname.split("/").slice(1)[1]
      }/${contact}`;
      router.push({
        pathname: fullPath,
      });
    }
  }

  if (!hasCompanyContactViewPermission && (isFreeUser || isPublicUser)) {
    return (
      <button
        type="button"
        style={{ color: "#2563eb", fontWeight: "bold" }}
        onClick={viewContactHandler}
      >
        Upgrade now to unlock
      </button>
    );
  }

  if (!hasCompanyContactViewPermission && (isSelectUser || isCorporateUser)) {
    return (
      <button
        type="button"
        style={{ color: "#2563eb", fontWeight: "bold" }}
        onClick={viewContactHandler}
      >
        Contact Sales to unlock
      </button>
    );
  }

  return (
    <button
      type="button"
      style={{ color: "#2563eb", fontWeight: "bold" }}
      onClick={viewContactHandler}
    >
      Contact Info
    </button>
  );
};

export default ContactInfoBtn;
